import React from "react";
import NewsPageSection from "../../Sections/NewsPageSection/Content";
const NewsPage = () => {
  return <NewsPageSection />;
};

export default NewsPage;
